import { render, staticRenderFns } from "./ArtistSearchCustomNickname.vue?vue&type=template&id=49170d32&scoped=true"
import script from "./ArtistSearchCustomNickname.vue?vue&type=script&lang=js"
export * from "./ArtistSearchCustomNickname.vue?vue&type=script&lang=js"
import style0 from "./ArtistSearchCustomNickname.vue?vue&type=style&index=0&id=49170d32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49170d32",
  null
  
)

export default component.exports